// extracted by mini-css-extract-plugin
export default {"colorPreview":"DufxKUxrn0Dho7Bp1ZZf","colorPickerLabel":"rwhudUGMkd_3LwTeW4Ms","required":"QwSrmJHjmIGqwomiYqB3","errorInput":"FVHAHnOcdbD3lEhTTjAO","error":"OObAIuxmNQJxYuhVZXp3"};